class YearMakeModel extends HTMLElement {
    constructor() {
        super();
        this.hubspotEventPushSelectors = this.querySelectorAll('[data-hubsport-event-push]');
    }
    async connectedCallback() {
        this.inputDefaultText = {
            "year" : "YEAR",
            "make": "MAKE",
            "model": "MODEL",
            "engine" : "ENGINE"
        }
        this._remove = false;
        await this._fetchAllVehiclesData();
        this._bindEvents('load');
        this._checkLocalStorageData();
        this._renderProductMainGrids();
        this._searchInput();
        // __st.p == "product" && theme?.globalVariable?.template != "detail-pdp" && this._pdpYmmAtcButton();
        // __st.p == "product" && theme?.globalVariable?.template == "detail-pdp" && this._fetchPDPYmmData();
        __st.p == "collection" && theme?.globalVariable?.template != "detail-plp" && this._pdpYmmAtcButton();
        __st.p == "collection" && theme?.globalVariable?.template == "detail-plp" && this._fetchPDPYmmData();

        this.hubspotEventPushSelectors.forEach(item => item.addEventListener('click', this._handleHubspotEventPush.bind(this)));
    }

    _handleHubspotEventPush(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        _hsq.push([
            'trackCustomBehavioralEvent',
            {
                name: 'pe7222820_vehicle_search_event__shopify__v4',
                properties: {
                    vehicle_year___search: this.selectedVehicle.year,
                    vehicle_make___search: this.selectedVehicle.make,
                    vehicle_model___search: this.selectedVehicle.model,
                    vehicle_engine___search: this.selectedVehicle.engine,
                },
            },
        ]);
        var redirectionLink = event.target.hasAttribute('data-redirection-link');
        if (redirectionLink) {
            window.location.href = event.target.href;
        }
    }

    async _fetchPDPYmmData() {
        const that = this;
        var submitBtn = this.querySelector('[data-ymm-submit]');
        if (submitBtn) {
            submitBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                submitBtn.classList.add('disabled');
                var vehicleUrl = submitBtn.href;
                var newVehicleJson = await that._newAjaxYmmUpdate(vehicleUrl);
                that._setupAllVehicles();
                await that._setupCartAttributeForFilter({_collection_handle: window.detailPDPData?._collection_handle || null});
                setTimeout(() => that._renderDetailPDPFilters(vehicleUrl), 800);
            })
        }
    }

    _handleRecentSearchDetailPDPYmm() {
        const that = this;
        var recentSearchResults = this.querySelectorAll('[data-ymm-collection-filter-handle]');
        if (recentSearchResults.length > 0) {
            recentSearchResults.forEach(item => {
                item.addEventListener('click', async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    var searchResutlsPanel = this.querySelector('.ymm-more-vehicle-data');
                    searchResutlsPanel.classList.add('disabled');
                    var vehicleUrl = item.href;
                    var newVehicleJson = await that._newAjaxYmmUpdate(vehicleUrl);
                    await that._setupCartAttributeForFilter({_collection_handle: window.detailPDPData?._collection_handle || null});
                    setTimeout(() => {
                        that._renderDetailPDPFilters(vehicleUrl)

                        // setup vehicle
                        let vehicle_configuration = localStorage.getItem('vehicle_configuration');
                        if (vehicle_configuration && vehicle_configuration != "[]") {
                            this.selectedVehicle = JSON.parse(vehicle_configuration)[0];
                            this._populateLocalStorageData(true);
                        }
                    }, 400);
                })
            })
            recentSearchResults[0].click();
        }
    }

    async _setupCartAttributeForFilter(attributes) {
        fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({attributes})
        })
        .then(response => response.json())
        .then(data => console.log('Cart attributes removed:', data))
        .catch(error => console.error('Error:', error));
    }

    // new detail pdp filters
    async _renderDetailPDPFilters(newURL) {
        var html = await ((await fetch(`${newURL}?view=detail-pdp-filter`)).text());
        this.querySelector('[data-detail-pdp-vehicle-filter]') && (this.querySelector('[data-detail-pdp-vehicle-filter]')?.classList.remove('d-none'),this.querySelector('[data-detail-pdp-vehicle-filter]').innerHTML = html);
        var submitBtn = this.querySelector('[data-ymm-submit]');
        submitBtn.classList.remove('disabled');
        var searchResutlsPanel = this.querySelector('.ymm-more-vehicle-data');
        searchResutlsPanel.classList.remove('disabled');
        await this._setupCartAttributeForFilter({_collection_handle: null});

        // setup vehicle
        let vehicle_configuration = localStorage.getItem('vehicle_configuration');
        if (vehicle_configuration && vehicle_configuration != "[]") {
            this.selectedVehicle = JSON.parse(vehicle_configuration)[0];
            this._populateLocalStorageData(true);
        }
    }

    _pdpYmmAtcButton() {
        const that = this;
        var pdpSubmitButton = this.querySelector('[data-pdp-ymm-submit-button]');
        if (pdpSubmitButton) {
            pdpSubmitButton.addEventListener('click', async (e) => {
                e.preventDefault();
                e.target?.classList.add('loading');
                var showError = false;
                var vehicleUrl = e.target.href;
                var newVehicleJson = await that._newAjaxYmmUpdate(vehicleUrl);
                var mainYmmSection = document.querySelector('.ymm-main-section-wrapper year-make-model');
                mainYmmSection && mainYmmSection.connectedCallback();
                setTimeout(() => {
                    e.target?.classList.remove('loading');
                    document.querySelector('#FindMyDevice')?.classList.remove('active');
                    document.body.classList.remove('open-cc--product');
                    var atcForm = document.querySelector('.product-information--inner .product-form form');
                    if (atcForm) atcForm.dispatchEvent(new Event('submit'));
                }, 1000);
            })
        }
    }

    async _newAjaxYmmUpdate(newURL) {
        var html = await ((await fetch(`${newURL}?view=ymm-available-json`)).text());
        html = JSON.parse(html) || null;
        var newVehicleData = html[0];
        newVehicleData['vehicle_categories'] = html[1];
        newVehicleData['availableProducts'] = html[2];
        newVehicleData['featureProducts'] = html[3];
        var vehicle_configuration_json = localStorage.getItem('vehicle_configuration');
        if (vehicle_configuration_json) {
            vehicle_configuration_json = JSON.parse(vehicle_configuration_json);
        } else {
            vehicle_configuration_json = [];
        }
        var newUpdatedJson = this.addUniqueObject(vehicle_configuration_json, newVehicleData);
        newUpdatedJson = JSON.stringify(newUpdatedJson);
        localStorage.setItem('vehicle_configuration', newUpdatedJson);
        return newUpdatedJson;
    }

    _searchInput = () => {
        var inputs = this.querySelectorAll('[data-search-input]');
        if (inputs.length > 0) {
            inputs.forEach(searchInput => {
                searchInput.addEventListener('input', (e) => {
                    var customSelect = e.currentTarget.closest('custom-select');
                    if(!customSelect) return;
                    var inputValues = customSelect.querySelectorAll('[data-selection-list] ul li');
                    if(!inputValues) return;
                    var value = e.target.value || null;
                    if(value == null) {
                        inputValues.forEach(item => item?.classList.remove('d-none'));
                        let last_child = customSelect?.querySelector('[data-selection-list] ul li:last-child');
                        last_child?.classList.add('d-none');
                    } else {
                        inputValues.forEach(item => {
                            var itemVal = item.getAttribute('data-select-value');
                            if(itemVal.toLowerCase().indexOf(value.toLowerCase()) > -1) {
                                item?.classList.remove('d-none');
                            } else {
                                item?.classList.add('d-none');
                            }
                        });
                        let last_child = customSelect?.querySelector('[data-selection-list] ul li:last-child');
                        if (last_child) {
                            if (customSelect.querySelectorAll('[data-selection-list] ul li.d-none').length == inputValues.length) {
                                last_child?.classList.remove('d-none');
                            }else {
                                last_child?.classList.add('d-none');
                            }
                        }
                    }
                })
            })
        }
    }

    _setupPdpYMMModel = (vehicleConfiguration) => {
        window.isProductCompatible = "No Data";
        if (__st.p == "product" && theme?.globalVariable?.template != "detail-pdp") {
            !this.closest('Model-Component') && this.classList.add('d-none');
            if (vehicleConfiguration != null && vehicleConfiguration != "[]" ) {
                var vehicleConfigurationData = JSON.parse(vehicleConfiguration)[0];
                var availableProducts = vehicleConfigurationData.availableProducts || [];
                if (availableProducts != null) {
                    availableProducts = typeof(availableProducts) == 'object' ? availableProducts : JSON.parse(availableProducts);
                    var pdpURL = window.location.pathname;
                    var items = availableProducts.filter(item => item.url === pdpURL);
                    if (items.length || this._isUniversalCompatible(window.jsProduct.tags, vehicleConfigurationData.year)) {
                        this.querySelector('[data-vehicle-selected] .selecte-vehicle-availability .vehicle-available')?.classList.remove('d-none');
                        this.querySelector('[data-vehicle-selected] .selecte-vehicle-availability .vehicle-not-available')?.classList.add('d-none');
                        this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-normal-heading]')?.classList.add('d-none');
                        this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-not-available-heading]')?.classList.add('d-none');
                        this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-available-heading]')?.classList.remove('d-none');
                        window.isProductCompatible = true;
                    } else {
                        this.querySelector('[data-vehicle-selected] .selecte-vehicle-availability .vehicle-available')?.classList.add('d-none');
                        this.querySelector('[data-vehicle-selected] .selecte-vehicle-availability .vehicle-not-available')?.classList.remove('d-none');
                        this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-normal-heading]')?.classList.add('d-none');
                        this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-not-available-heading]')?.classList.remove('d-none');
                        this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-available-heading]')?.classList.add('d-none');
                        window.isProductCompatible = false;
                    }
                } else {
                    this.querySelector('[data-vehicle-selected] .selecte-vehicle-availability .vehicle-available')?.classList.add('d-none');
                    this.querySelector('[data-vehicle-selected] .selecte-vehicle-availability .vehicle-not-available')?.classList.remove('d-none');
                    this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-normal-heading]')?.classList.add('d-none');
                    this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-not-available-heading]')?.classList.remove('d-none');
                    this.querySelector('[data-vehicle-selected] .selected-vehicle-data [data-vehicle-available-heading]')?.classList.add('d-none');
                }
                this.classList.remove('d-none');
            }
        }
    }

    _renderProductMainGrids = () => {
        var vehicleConfiguration = localStorage.getItem('vehicle_configuration');
        var ymmProductWrapper = document.querySelector('[data-ymm-products-wrapper]');
        this._setupPdpYMMModel(vehicleConfiguration);
        if (vehicleConfiguration && vehicleConfiguration != "[]" && ymmProductWrapper) {
            var vehicleConfiguration = JSON.parse(vehicleConfiguration)[0];
            this._setupAllVehiclesCategories(vehicleConfiguration);

            (vehicleConfiguration.url != null && vehicleConfiguration.url != undefined) ? 
                document.querySelector('.thb-secondary-mycar')?.setAttribute('href', vehicleConfiguration.url) : 
                document.querySelector('.thb-secondary-mycar')?.classList.add('d-none');
            
            if ((vehicleConfiguration?.availableProducts?.length > 0 && vehicleConfiguration?.availableProducts != undefined) ||
                (vehicleConfiguration?.featureProducts?.length > 0 && vehicleConfiguration?.featureProducts != undefined)) {
                var availableProducts = typeof(vehicleConfiguration?.featureProducts) == "object" ? vehicleConfiguration?.featureProducts : (JSON.parse(vehicleConfiguration?.featureProducts));
                if (vehicleConfiguration?.featureProducts === undefined) {
                    localStorage.removeItem("vehicle_configuration");
                    window.location.reload();
                }
                if (availableProducts === undefined || availableProducts.length == 0) {
                    availableProducts = typeof(vehicleConfiguration?.availableProducts) == "object" ? vehicleConfiguration?.availableProducts : (JSON.parse(vehicleConfiguration?.availableProducts));
                }
                if (availableProducts.length > 0) {
                    document.querySelector('#main-content > .section-slideshow')?.classList.add('d-none');
                    document.querySelector('#main-content > .section-slideshow')?.classList.remove('opacity-0');
                    availableProducts = availableProducts.slice(0, 5);
                    var prCount = availableProducts.length;
                    var prHtml = `<div class="row product-blocks-${prCount}">`;
                    availableProducts.forEach((pr, index) => {
                        prHtml += `<div class="product-blocks-wrap product-index-${index+1}">
                                    <div class="product-container rounded-1-5">
                                        <a href="${pr.url}" title="${pr.keyfeature_ele}" role="link" class="">
                                            <div class="text-center img-wrapper p-2 pe-0">
                                                <img src="${pr.image}" width="100%" height="100%" loading="lazy" alt="${pr.title}" />
                                            </div>
                                        </a>
                                        <div class="content-wrap">
                                        <a href="${pr.url}" title="${pr.keyfeature_ele}" role="link" class="">
                                            <h2 class="${index == 0 ? 'fw-acumin-900' : 'fw-acumin-800'} heading font-acumin text-uppercase">${pr.title}</h2>
                                        </a>
                                        <p class="product--text mt-0 normal_grayed ${(!pr.fitmenttitle && pr.fitmenttitle == "") && "d-none"}">${pr.fitmenttitle}</p>
                                        <span class="fw-acumin-800 subheading mb-0">${pr.product_category}</span>
                                        <p class="content font-roboto text-black fw-normal">${pr.keyfeature_ele}</p>
                                        <a href="${pr.url}" title="${pr.keyfeature_ele}" role="link" class="text-button button mt-2 text-button--has-icon">Learn More</a>
                                        <a href="${pr.url}" title="${pr.keyfeature_ele}" role="link" class="text-button link-btn text-button--has-icon font-roboto">configure <span>
                                        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></a>
                                        </div>
                                    </div>
                                </div>`;
                    })
                    prHtml += `</div>`;   
                    ymmProductWrapper.innerHTML = prHtml;
                    ymmProductWrapper.classList.remove('d-none');
                }else{
                    document.querySelector('#main-content > .section-slideshow')?.classList.remove('opacity-0', 'd-none');
                    window.dispatchEvent(new Event('resize'));
                    ymmProductWrapper.classList.add('d-none');
                }
            }else{
                document.querySelector('#main-content > .section-slideshow')?.classList.remove('opacity-0', 'd-none');
                window.dispatchEvent(new Event('resize'));
            }
        }else{
            ymmProductWrapper?.classList.remove('d-none');
            document.querySelector('.thb-secondary-mycar')?.classList.add('d-none');
            document.querySelector('#main-content > .section-slideshow')?.classList.remove('opacity-0', 'd-none');
            window.dispatchEvent(new Event('resize'));
        }
    }
 
    _bindEvents = (eventType = false) => {
        this.querySelectorAll('[data-ymm-type] [data-selection-list] button')
            .forEach(item => item.addEventListener('click', this._onItemClick.bind(this)));
        
        //if (current_template == 'metaobject/vehicle_configuration' && eventType == "load") {
        if (current_template.includes('metaobject/vehicle_configuration') && eventType == "load") {
            this._storeInLocalStorage();
            this._setupCategoryFilter();
        }

        this.querySelectorAll('[data-configuration]').forEach(ele => ele.addEventListener('click', this._configurationAction.bind(this)));

        document.querySelectorAll('[data-item-product-type]').forEach((ele)=>{
            ele.addEventListener('click',(event)=>{
                let href = ele.querySelector('[data-product-url][href]').getAttribute('href');
                window.location.href=href;
            })
        })
    }

    _setupCategoryFilter = () => {
        var category = window.location.hash;
        if (category) {
            var el = document.querySelector(`category-card a[href="${category}"]`);
            if(el) el.closest('[data-category-type]')?.dispatchEvent(new Event('click'));
        }
    }

    _configurationAction = async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        let type = event.target.closest('[data-configuration]').getAttribute('data-configuration');
        if (type == 'remove') {
            localStorage.removeItem("vehicle_configuration");
            window.location.href = "/";
        } else if (type == 'remove_homepage') {
            // let vehicle_configuration = JSON.parse(localStorage.getItem("vehicle_configuration"));
            // vehicle_configuration.shift();
            // localStorage.setItem("vehicle_configuration", JSON.stringify(vehicle_configuration));
            localStorage.removeItem("vehicle_configuration");
            // this.connectedCallback();
            // this._renderProductMainGrids();
            document.querySelector('#main-content > .section-slideshow')?.classList.remove('opacity-0', 'd-none');
            window.dispatchEvent(new Event('resize'));
            this._setupAllVehicles();
            this._toggleVehicleSelectedDisplay(false, true);
            setTimeout(() => {
                this.querySelector('[data-detail-pdp-vehicle-filter]')?.classList.add('d-none');
            }, 1500);
            document.querySelector('[data-ymm-products-wrapper]')?.classList.add('d-none');
            return;
        } else if (type == 'change' && __st.p == "collection" && theme?.globalVariable?.template == "detail-plp") {
            this.querySelector('[data-vehicle-selected="false"]')?.classList.remove('d-none');
            this.querySelector('[data-vehicle-selected="true"]')?.classList.add('d-none');
            return;
        }
        this._populateFields();
        await this._setupAllVehicles();
        this._toggleVehicleSelectedDisplay(false);
    }

    _setupAllVehicles = () => {
        const that = this;
        var vehicle_configuration_json = localStorage.getItem('vehicle_configuration');
        if (vehicle_configuration_json && vehicle_configuration_json != "[]") {
            vehicle_configuration_json = JSON.parse(vehicle_configuration_json);
            if (vehicle_configuration_json.length > 0) {
                var vehicleHtml = ``;
                vehicle_configuration_json.forEach((obj, index) => {
                    var url = this.getURLForYearMakeModelAndEngine(obj.year, obj.make, obj.model, obj.engine);
                    let ymm_handel = `year_${obj.year}_make_${obj.make.replaceAll(" ", "-")}_model_${obj.model.replaceAll(" ", "-")}_engine_${obj.engine.replaceAll(".", "-").replaceAll(" ", "-")}`;
                    var isActivated = window.location.href.includes(ymm_handel) ? true : false;
                    vehicleHtml += `<div class="swiper-slide vehicle--data"><a href="/pages/vehicle-configuration/${url}" data-ymm-collection-filter-handle="${ymm_handel}" data-ymm-collection-filter-activated="${isActivated}" data-ymm-collection-filter-index="${index}" class="font-roboto fw-bold text-uppercase">${obj.year} ${obj.make} ${obj.model} ${obj.engine}</a></div>`;
                })
                const vehicleDatHtml = this.querySelector('.ymm-more-vehicle .ymm-more-vehicle-data');
                if (vehicleDatHtml && vehicleHtml.length > 0) {
                    vehicleDatHtml.innerHTML = this._recentSearchHtml(vehicleHtml);
                    if(__st.p == "collection" && theme?.globalVariable?.template != "detail-plp") {
                        var allYmmVehicleLists = this.querySelectorAll('.ymm-more-vehicle-data [data-ymm-collection-filter-handle]');
                        allYmmVehicleLists.forEach(item => {
                            item.addEventListener('click', (event) => {
                                event.preventDefault();
                                event.stopImmediatePropagation();
                                allYmmVehicleLists.forEach(el => el.setAttribute('data-ymm-collection-filter-activated', false));
                                item.setAttribute('data-ymm-collection-filter-activated', true)
                                that._updateURL(item.getAttribute('data-ymm-collection-filter-handle'))
                            })
                        })
                    }
                }
                this.querySelector('.ymm-more-vehicle')?.classList.remove('d-none');
            } else {
                this.querySelector('.ymm-more-vehicle')?.classList.add('d-none');
            }
        } else {
            this.querySelector('.ymm-more-vehicle')?.classList.add('d-none');
        }
        __st.p == "product" && theme?.globalVariable?.template == "detail-pdp" && this._handleRecentSearchDetailPDPYmm();
        __st.p == "collection" && theme?.globalVariable?.template == "detail-plp" && this._handleRecentSearchDetailPDPYmm();

    }

    _recentSearchHtml=(vehicleHtml)=>{
        return(`
            <slider-element>
                <div class="swiper swiper-slider" data-slider='{
                            "loop": false,
                            "slidesPerView": "auto",
                            "spaceBetween": 16,
                            "grabCursor": true
                        }'>
                        <div class="swiper-wrapper align-items-center">
                            <div class="swiper-slide vehicle--data">
                                <span class="fw-acumin-700 text-uppercase search-text">Recent Search</span>
                            </div>
                            ${vehicleHtml}
                        </div>
                </div>
            </slider-element>
        `);
    }

    _setupAllVehiclesCategories = (vehicle_configuration_json) => {
        if(vehicle_configuration_json != null) {
            var vehicleCategories = typeof(vehicle_configuration_json.vehicle_categories) == "object" ? vehicle_configuration_json.vehicle_categories : (JSON.parse(vehicle_configuration_json.vehicle_categories) || []);
            if (vehicleCategories.length > 0) {
                var vehicleCategoryHtml = ``;
                var url = this.getURLForYearMakeModelAndEngine(vehicle_configuration_json.year, vehicle_configuration_json.make, vehicle_configuration_json.model, vehicle_configuration_json.engine);
                vehicleCategories.forEach((obj, index) => {  
                    vehicleCategoryHtml += `<div class="col-4 col-lg-2 mb-3">
                                                <category-card>
                                                    <a href="${vehicle_configuration_json.vehicle_categories_url}#${obj.handle}" class="category-card">
                                                        <div class="category-image">
                                                            <img src="${obj.featured_image}" width="100%" height="100%">
                                                        </div>
                                                        <div class="category-content">
                                                            <div class="category-title">
                                                                <h3 class="fw-bold">${obj.title}</h3>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </category-card>
                                            </div>`;
                });
                var catParent = document.querySelector('.shopify-section.collections-list-section [data-vehicle-category]');
                if(catParent) catParent.innerHTML = vehicleCategoryHtml;
            }
        }
    }

    _storeInLocalStorage = () => {
        // event.preventDefault();
        // event.stopImmediatePropagation();
        // if (this.selectedVehicle['url']) {
        //     if (this.querySelector('[data-selected-vehicle="image"] img')) {
        //         this.selectedVehicle['image'] = this.querySelector('[data-selected-vehicle="image"] img').getAttribute('src');
        //     }else{
        //         this.selectedVehicle['image'] = "";
        //     }
        //     localStorage.setItem('vehicle_configuration', JSON.stringify(this.selectedVehicle));
        // }
        // window.location.href = event.target.getAttribute('href');

        this.selectedVehicle = {
            "year" : "false",
            "make" : "false",
            "model" : "false",
            "engine" : "false",
            "image" : "",
            "url" : "",
            "handle" : "",
            "vehicle_configuration" : "[]"
        };
        ["year","make","model","engine"].forEach((type)=>{
            this.selectedVehicle[type] = this.querySelector(`[data-ymm-type="${type}"] [data-selected-field]`)?.getAttribute('data-selected-field')
        });
        let availableProducts = [];
        document.querySelectorAll('[data-display-type="list"] [data-item-product-type]').forEach((ele)=>{
            let productDetails = ele.querySelectorAll('[data-product-details]');
            let obj = {};
            productDetails.forEach((pd)=>{
                if (pd.getAttribute('data-product-details') == 'image') {
                    obj[pd.getAttribute('data-product-details')] = pd.getAttribute('src');
                }else{
                    obj[pd.getAttribute('data-product-details')] = pd.innerText;
                }
            })
            obj['handle'] = ele.querySelector('[data-product-url]').getAttribute('data-handle');
            obj['url'] = ele.querySelector('[data-product-url]').getAttribute('href');
            obj['fitmenttitle'] = ele.querySelector('[data-product-details="fitmenttitle"]')?.innerHTML || "";
            obj['id'] = ele.querySelector('[data-product-details="productId"]')?.innerHTML || "";
            availableProducts.push(obj);
        })
        var featureProducts = JSON.parse(document.querySelector('script[data-feature-product-data]')?.innerHTML) || [];
        this.selectedVehicle['featureProducts'] = featureProducts;
        this.selectedVehicle['url'] = this.querySelector('[data-ymm-submit]')?.getAttribute('href');
        if (this.querySelector('[data-selected-vehicle="image"] img')) {
            this.selectedVehicle['image'] = this.querySelector('[data-selected-vehicle="image"] img').getAttribute('src');
        }else{
            this.selectedVehicle['image'] = "";
        }
        this.selectedVehicle['availableProducts'] = JSON.stringify(availableProducts);
        var vehicleType = document.querySelector('script[data-vehicle_categories]')?.innerHTML || [];
        this.selectedVehicle['vehicle_categories'] = vehicleType;
        this.selectedVehicle['vehicle_categories_url'] = window.location.pathname;
        var vehicle_configuration_json = localStorage.getItem('vehicle_configuration');
        if (vehicle_configuration_json) {
            vehicle_configuration_json = JSON.parse(vehicle_configuration_json);
        } else {
            vehicle_configuration_json = [];
        }
        var newUpdatedJson = this.addUniqueObject(vehicle_configuration_json, this.selectedVehicle);
        newUpdatedJson = JSON.stringify(newUpdatedJson);
        localStorage.setItem('vehicle_configuration', newUpdatedJson);
    }

    addUniqueObject(array, newObj) {
        const existingIndex = array.findIndex(obj =>
            obj.year === newObj.year &&
            obj.make === newObj.make &&
            obj.model === newObj.model &&
            obj.engine === newObj.engine
        );
        if (existingIndex !== -1) { array.splice(existingIndex, 1); }
        array.unshift(newObj);
        return array;
    }      

    _checkLocalStorageData = () => {
        let vehicle_configuration = localStorage.getItem('vehicle_configuration');
        window.collectionPageNoFilter = false;
        window.customSearchOnCollection = false;
        this._setupAllVehicles();
        if (vehicle_configuration && vehicle_configuration != "[]") {
            this.selectedVehicle = JSON.parse(vehicle_configuration)[0];
            ["year","make","model","engine"].forEach((type)=>{
                this.querySelector(`[data-ymm-type="${type}"] [data-selected-field]`)?.setAttribute('data-selected-field',this.selectedVehicle[type])
            });
            if (!window.current_template.includes('metaobject/vehicle_configuration')) {
                this._populateLocalStorageData();
            }
            this._toggleVehicleSelectedDisplay(true, true);
        } else {
            this._toggleVehicleSelectedDisplay(false, true);
        }
    }

    _populateLocalStorageData = (showResultWrapper = false) => {
        let ymm = `${this.selectedVehicle.year} ${this.selectedVehicle.make} ${this.selectedVehicle.model} ${this.selectedVehicle.engine}`;
        let ymm_handel = `year_${this.selectedVehicle.year}_make_${this.selectedVehicle.make.replaceAll(" ", "-")}_model_${this.selectedVehicle.model.replaceAll(" ", "-")}_engine_${this.selectedVehicle.engine.replaceAll(".", "-").replaceAll(" ", "-")}`;
        (this.querySelector('[data-selected-vehicle="name"]')) && (this.querySelector('[data-selected-vehicle="name"]').innerHTML = `${this.selectedVehicle.year != "false" ? ymm : ''}`);
        (this.querySelector('[data-selected-vehicle="name"]')) && (this.querySelector('[data-selected-vehicle="name"]').setAttribute('data-ymm-handle', ymm_handel));
        if (this.selectedVehicle.image != "" && this.selectedVehicle.image.length > 0) {
            this.querySelector('[data-selected-vehicle="image"] img')?.setAttribute('src', this.selectedVehicle.image)
        }else {
            this.querySelector('[data-selected-vehicle="image"]')?.classList.remove('d-md-block');
        }
        var URL = this.getURLForYearMakeModelAndEngine(this.selectedVehicle.year, this.selectedVehicle.make, this.selectedVehicle.model, this.selectedVehicle.engine);
        this.querySelectorAll('[data-redirection-link]')?.forEach(item => item.setAttribute('href', `/pages/vehicle-configuration/${URL}`));
        document.querySelector('[data-shop-compatible-vehicle]')?.addEventListener('click', e => window.location.href = `/pages/vehicle-configuration/${URL}`); 
        if (showResultWrapper) {
            this.querySelector('[data-vehicle-selected="false"]')?.classList.add('d-none');
            this.querySelector('[data-vehicle-selected="true"]')?.classList.remove('d-none');
        }
    }

    _toggleVehicleSelectedDisplay = (isSelected, updateURL = false) => {
        this.querySelector('[data-vehicle-selected="false"]')?.classList.toggle('d-none', isSelected);
        this.querySelector('[data-vehicle-selected="true"]')?.classList.toggle('d-none', !isSelected);
        if (__st.p == "collection" && theme?.globalVariable?.template != "detail-plp") {
            this.querySelector('[data-vehicle-selected="false"]')?.classList.add('d-none');
            if(window.customSearchOnCollection == false) {
                if (window.location.href.includes('page=')) {
                    var ymmName = document.querySelector('[data-ymm-collection-filter-handle][data-ymm-collection-filter-activated="true"]')?.innerHTML;
                    var ymmName_handle = document.querySelector('[data-ymm-collection-filter-handle][data-ymm-collection-filter-activated="true"]')?.getAttribute('data-ymm-collection-filter-handle');
                } else {
                    var ymmName = (document.querySelector('[data-ymm-collection-filter-handle][data-ymm-collection-filter-activated="true"]')?.innerHTML || document.querySelector('[data-ymm-collection-filter-handle][data-ymm-collection-filter-index="0"]')?.innerHTML);
                    var ymmName_handle = (document.querySelector('[data-ymm-collection-filter-handle][data-ymm-collection-filter-activated="true"]')?.getAttribute('data-ymm-collection-filter-handle') || document.querySelector('[data-ymm-collection-filter-handle][data-ymm-collection-filter-index="0"]')?.getAttribute('data-ymm-collection-filter-handle'));
                }
            } else {
                document.querySelector('[data-applied-filter] [data-selected-category]') && (document.querySelector('[data-applied-filter] [data-selected-category]').innerHTML = window.customSearchOnCollection);
            }
            if (window.collectionPageNoFilter == false) {
                this.querySelector('[data-vehicle-selected="true"]')?.classList.add('d-none');   
                document.querySelector('[data-applied-filter]')?.classList.remove('d-none');
                if (!window.location.href.includes('page=')) {
                    if (ymmName === undefined && ymmName_handle === undefined && window.customSearchOnCollection == false) {
                        this._updateURL(false);
                    } else {
                        (!window.location.href.includes(ymmName_handle) && updateURL && ymmName_handle) && this._updateURL(ymmName_handle);
                    }   
                } else {
                    if (ymmName === undefined && ymmName_handle === undefined && window.customSearchOnCollection == false) {
                        this.querySelector('[data-vehicle-selected="false"]')?.classList.remove('d-none');   
                        this.querySelector('[data-vehicle-selected="true"]')?.classList.add('d-none');      
                        document.querySelector('[data-applied-filter]')?.classList.add('d-none');
                    }
                }
                ymmName !== undefined && this._setupCollectionPageCategoryCard(ymmName);
            } else {
                this.querySelector('[data-vehicle-selected="false"]')?.classList.remove('d-none');   
                this.querySelector('[data-vehicle-selected="true"]')?.classList.add('d-none');   
                if (document.body.classList.contains('template-collection-parent')) {
                    document.querySelector(`.collection-subcollection-slider .shop-category`)?.classList.remove('d-none');
                    document.querySelectorAll('.collection-subcollection-slider [data-category-item-handle]').forEach(item => item.classList.remove('d-none'));
                }
            }
            this._setupCollectionFilterAndYmm(ymmName, ymmName_handle);
        }
    }

    _setupCollectionPageCategoryCard(vehicleName) {
        if (document.body.classList.contains('template-collection-parent')) {
            var vehicle_configuration_json = localStorage.getItem('vehicle_configuration');
            if (vehicle_configuration_json) {
                vehicle_configuration_json = JSON.parse(vehicle_configuration_json);
            } else {
                vehicle_configuration_json = [];
            }
            if (vehicle_configuration_json.length > 0) {
                var activated = vehicle_configuration_json.filter(item => `${item.year} ${item.make} ${item.model} ${item.engine}` === vehicleName);
                if (activated.length > 0) {
                    document.querySelectorAll('.collection-subcollection-slider [data-category-item-handle]').forEach(item => item.classList.add('d-none'));
                    var vehicleCategories = typeof(activated[0]?.vehicle_categories) == "object" ? activated[0]?.vehicle_categories : (JSON.parse(activated[0]?.vehicle_categories) || []);
                    vehicleCategories?.forEach(cat => {
                        document.querySelector(`.collection-subcollection-slider [data-category-item-handle="${cat.handle}"]`)?.classList.remove('d-none');
                    })
                } else {
                    document.querySelector(`.collection-subcollection-slider .shop-category`)?.classList.remove('d-none');
                    document.querySelectorAll('.collection-subcollection-slider [data-category-item-handle]').forEach(item => item.classList.remove('d-none'));
                }
            } else {
                document.querySelector(`.collection-subcollection-slider .shop-category`)?.classList.remove('d-none');
                document.querySelectorAll('.collection-subcollection-slider [data-category-item-handle]').forEach(item => item.classList.remove('d-none'));
            }
            var allVisibleCategories = document.querySelectorAll(`.collection-subcollection-slider [data-category-item-handle]:not(.d-none)`);
            allVisibleCategories.forEach(cat => {
                var catTitle = cat.getAttribute('data-category-item-title');
                var availability = document.querySelector(`#ProductGridContainer [data-product-details-category="${catTitle}"]`);
                if (!availability) {
                    cat.classList.add('d-none');
                }
            })
            var catVisible = document.querySelector(`.collection-subcollection-slider [data-category-item-handle]:not(.d-none)`);
            if (catVisible) {
                document.querySelector(`.collection-subcollection-slider .shop-category`)?.classList.remove('d-none');
            } else {
                document.querySelector(`.collection-subcollection-slider .shop-category`)?.classList.add('d-none');
            }
        }
    }

    async _setupCollectionFilterAndYmm(vehicleName, vehicleNameHandle) {
        const that = this;
        if(window.customSearchOnCollection == false) document.querySelector('[data-applied-filter] [data-selected-category]') && (document.querySelector('[data-applied-filter] [data-selected-category]').innerHTML = vehicleName);
        var allCollectionYmmFilter = document.querySelectorAll('[data-remove-collection-ymm-filter]');
        allCollectionYmmFilter.forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                document.querySelector('[data-applied-filter]')?.classList.add('d-none');
                document.querySelector('#main-content year-make-model [data-vehicle-selected="false"]')?.classList.remove('d-none');
                that._updateURL(false);
            })
        })
        this._setupAllVehicles();
        this._setupYMMfilterOnCollectionPage();
    }

    _setupYMMfilterOnCollectionPage() {
        const that = this;
        window.customSearchOnCollection = false;
        var submitBtn = this.querySelector('[data-ymm-submit]');
        if (submitBtn != null) {
            submitBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();
                var yearValue = this.querySelector('[data-ymm-type="year"] [data-selection-list] li button.custom-select--item-active')?.innerHTML?.trim() || null;
                var makeValue = this.querySelector('[data-ymm-type="make"] [data-selection-list] li button.custom-select--item-active')?.innerHTML?.trim() || null;
                var modelValue = this.querySelector('[data-ymm-type="model"] [data-selection-list] li button.custom-select--item-active')?.innerHTML?.trim() || null;
                var engineValue = this.querySelector('[data-ymm-type="engine"] [data-selection-list] li button.custom-select--item-active')?.innerHTML?.trim() || null;
                if (yearValue && makeValue && modelValue && engineValue) {
                    var vehicleName = `${yearValue} ${makeValue} ${modelValue} ${engineValue}`;
                    var vehicleNameHandle = `year_${yearValue.replaceAll(" ", "-")}_make_${makeValue.replaceAll(" ", "-")}_model_${modelValue.replaceAll(" ", "-")}_engine_${engineValue.replaceAll(".", "-").replaceAll(" ", "-")}`;
                    that._setupCollectionFilterAndYmm(vehicleName, vehicleNameHandle);
                    window.customSearchOnCollection = vehicleName;
                    var vehicleUrl = submitBtn.href;
                    var newVehicleJson = await that._newAjaxYmmUpdate(vehicleUrl);
                    await that._setupAllVehicles();
                    that._updateURL(vehicleNameHandle);
                    if (document.body.classList.contains('template-collection-parent')) {
                        document.querySelector(`.collection-subcollection-slider .shop-category`)?.classList.remove('d-none');
                        document.querySelectorAll('.collection-subcollection-slider [data-category-item-handle]').forEach(item => item.classList.remove('d-none'));
                    }
                    that._setupCollectionPageCategoryCard(vehicleName);
                }
            })
        }
    }

    _updateURL(newParam) {
        let staticURL = `${window.location.origin}${document.querySelector('body').getAttribute('data-collection-url')}`
        let url = new URL(staticURL);
        window.collectionPageNoFilter = false;
        if (newParam != false) {
            let pathSegments = url.pathname.split('/');
            if (pathSegments.length > 2) {
                pathSegments.splice(3, 0, newParam);
            }
            url.pathname = pathSegments.join('/');
            window.collectionPageNoFilter = false;
        } else {
            window.collectionPageNoFilter = true;
        }
        window.history.pushState({}, '', url.href);
        this._updateFilterData();
    }

    async _updateFilterData() {
        var url = window.location.pathname;
        var html = await ((await fetch(`${url}?view=ymm-filter`)).text());
        var sectionId = document.querySelector('#ProductGridContainer #product-grid')?.getAttribute('data-id');
        document.querySelector('[data-collection-main-product-wrapper]') ? (document.querySelector('[data-collection-main-product-wrapper]').innerHTML = html) : "";
        document.querySelector('#ProductGridContainer #product-grid')?.setAttribute('data-id', sectionId);
        var prCount = document.querySelector('#ProductGridContainer #product-grid [data-collection-product-item-count]')?.getAttribute('data-collection-product-item-count');
        (document.querySelector('[data-result-items]')) && (document.querySelector('[data-result-items]').innerHTML = prCount);
        var activatedCardLayout = document.querySelector('[type="radio"][name="display_type"]:checked').value;
        document.querySelectorAll('[data-display-type]').forEach(item => item.classList.add('d-none'));
        document.querySelector(`[data-display-type="${activatedCardLayout}"]`)?.classList.remove('d-none');
        this._toggleVehicleSelectedDisplay(true, true);
    }

    _populateFields = () => {
        this.querySelectorAll('[data-ymm-type]').forEach((ele) => {
            let type = ele.getAttribute('data-ymm-type');
            let value = this.selectedVehicle[type] || false;
            if (value == 'false') {
                if (type == 'year') {
                    ele.querySelector(`[data-selection-list] [data-value="${value}"]`)?.click();
                }
            } else {
                setTimeout(() => {
                    ele.querySelector(`[data-selection-list] [data-value="${value}"]`)?.click();
                }, 100);
            }
        });
    }

    _onItemClick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        let closestElement = event.target.closest('custom-select');
        let selectedValue = event.target.getAttribute('data-value');
        let selectedInnerText = event.target.textContent;
        closestElement.querySelector('.custom-select--item-active')?.classList.remove('custom-select--item-active');
        closestElement.querySelector('.custom-select--active')?.classList.remove('custom-select--active');
        event.target?.classList.add('custom-select--item-active');
        if (closestElement) {
            closestElement.hidePanel();
            if (closestElement.querySelector('[data-selected-field]')) {
                closestElement.querySelector('[data-selected-field]')?.setAttribute('data-selected-field', selectedValue);
                closestElement.querySelector('[data-selected-field]').innerHTML = selectedInnerText;
            }

            let fieldType = closestElement.getAttribute('data-ymm-type');
            this._manageVisibilityOfFields(fieldType);
        }
    }

    _fetchAllVehiclesData = async () => {
        this.vehiclesData = [];
        try {
            let response = await fetch(window.vehicle_data_csv);
            if (response.ok) {
                let data = await response.text();
                this.vehiclesData.push(this._convertCSVToArray(data));
                this.vehiclesData = [].concat(...this.vehiclesData);
                this.convertArrayToJSON();
                this._populateData("year");
                this._populateFields();
            } else {
                throw new Error('Failed to fetch data');
            }
        } catch (error) {
            console.error(error, 'error');
        }
    }

    _convertCSVToArray = (csv) => {
        const lines = csv.split('\n');
        const result = [];
        const headers = lines[0].split(',');

        for (let i = 1; i < lines.length; i++) {
            const obj = {};
            const currentLine = lines[i].split(',');

            for (let j = 0; j < headers.length; j++) {
                obj[headers[j].trim()] = currentLine[j].trim();
            }

            result.push(obj);
        }

        return result;
    }

    _manageVisibilityOfFields = (field) => {
        this.querySelectorAll('[data-ymm-type]').forEach(ele => {
            ele.classList.remove('disabled');
        });
        this._disableSubmitButton();

        switch (field) {
            case 'year':
                this._disableFields(['model', 'engine']);
                this._populateData('make');
                break;
            case 'make':
                this._disableFields(['engine']);
                this._populateData('model');
                break;
            case 'model':
                this._populateData('engine');
                break;
            case 'engine':
                this._populateData('endresult');
                break;
        }
    }

    _disableFields = (fields) => {
        fields.forEach(field => {
            this.querySelector(`[data-ymm-type="${field}"]`)?.classList.add('disabled');
            let selectedFieldEle = this.querySelector(`[data-ymm-type="${field}"] [data-selected-field]`);
            if (selectedFieldEle) {
                selectedFieldEle.setAttribute('data-selected-field', 'false');
                selectedFieldEle.innerHTML = this.inputDefaultText[field];
            }
        });
    }

    _disableSubmitButton = () => {
        this.querySelector('[data-ymm-submit]')?.classList.add('disabled');
        this.querySelector('[data-ymm-submit]')?.setAttribute('disabled', true);
    }

    _enableSubmitButton = (href) => {
        this.querySelector('[data-ymm-submit]')?.classList.remove('disabled');
        this.querySelector('[data-ymm-submit]')?.removeAttribute('disabled');
        this.querySelector('[data-ymm-submit]')?.setAttribute('href', href);
        this.querySelector('[data-redirection-link]')?.setAttribute('href', href);
        document.querySelector('[data-shop-compatible-vehicle]')?.addEventListener('click', e => window.location.href = href);
    }

    _populateData = async (type = 'year') => {
        this.yearEle = this.querySelector('[data-ymm-type="year"]');
        this.makeEle = this.querySelector('[data-ymm-type="make"]');
        this.modelEle = this.querySelector('[data-ymm-type="model"]');
        this.engineEle = this.querySelector('[data-ymm-type="engine"]');

        let selectedYearValue = this._remove ? "false" : this.yearEle.querySelector('[data-selected-field]')?.getAttribute('data-selected-field');
        let selectedMakeValue = this._remove ? "false" : this.makeEle.querySelector('[data-selected-field]')?.getAttribute('data-selected-field');
        let selectedModelValue = this._remove ? "false" : this.modelEle.querySelector('[data-selected-field]')?.getAttribute('data-selected-field');
        let selectedEngineValue = this._remove ? "false" : this.engineEle.querySelector('[data-selected-field]')?.getAttribute('data-selected-field');


        this.selectedVehicle = {
            'year': selectedYearValue,
            'make': selectedMakeValue,
            'model': selectedModelValue,
            'engine': selectedEngineValue
        }

        switch (type) {
            case 'year':
                this._populateYears();
                break;
            case 'make':
                this._remove = false;
                this._populateMakes();
                break;
            case 'model':
                this._populateModels();
                break;
            case 'engine':
                this._populateEngines();
                break;
            case 'endresult':
                this._populateEndResult();
                break;
        }

        this._bindEvents();
    }

    _populateYears = () => {
        this.years = this.getAllYears();
        this.years = [...new Set(this.years)].sort((a, b) => b - a);
        let html = this._createOption(this.inputDefaultText.year, false);
        this.years.forEach(year => {
            html += this._createOption(year);
        });
        html += this._createOption('No Results Found');

        this.yearEle.querySelector('.custom-select--list ul').innerHTML = html;
        let last_child = this.yearEle.querySelector('.custom-select--list ul li:last-child');
        if (last_child) {
            last_child?.classList.add('d-none');
        }
        this.yearEle.classList.remove('disabled');
    }

    _populateMakes = () => {
        this.make = this.getAllMakesForYear(this.selectedVehicle.year);
        let selectedFieldEle = this.querySelector(`[data-ymm-type="make"] [data-selected-field]`);
        if (selectedFieldEle) {
            selectedFieldEle.setAttribute('data-selected-field', 'false');
            selectedFieldEle.innerHTML = this.inputDefaultText['make'];
        }
        if (this.make.length == 0) {
            this._disableFields(['make']);
        }else {
            this._populateSelect(this.makeEle, this.make, this.inputDefaultText.make);
        }
    }

    _populateModels = () => {
        this.model = this.getAllModelsForYearAndMake(this.selectedVehicle.year, this.selectedVehicle.make);
        if (this.model.length == 0) {
            this._disableFields(['model']);
        }else {
            this._populateSelect(this.modelEle, this.model, this.inputDefaultText.model);
        }
    }

    _populateEngines = () => {
        this.engine = this.getAllEnginesForYearMakeAndModel(this.selectedVehicle.year, this.selectedVehicle.make, this.selectedVehicle.model);
        if (this.engine.length == 0) {
            this._disableFields(['engine']);
        }else {
            this._populateSelect(this.engineEle, this.engine, this.inputDefaultText.engine);
        }
    }

    _populateEndResult = () => {
        let result = this.getURLForYearMakeModelAndEngine(this.selectedVehicle.year, this.selectedVehicle.make, this.selectedVehicle.model, this.selectedVehicle.engine);
        if (result) {
            this.selectedVehicle['url'] = result;
            this._enableSubmitButton(`/pages/vehicle-configuration/${result}`);
        } else {
            this._disableSubmitButton();
        }
    }

    _populateSelect = (element, items, defaultText) => {
        let html = this._createOption(defaultText, false);
        items.forEach(item => {
            html += this._createOption(item);
        });
        html += this._createOption('No Results Found');
        element.querySelector('.custom-select--list ul').innerHTML = html;
        let last_child = element.querySelector('.custom-select--list ul li:last-child');
        if (last_child) {
            last_child?.classList.add('d-none');
        }
        element.classList.remove('disabled');
    }

    _createOption = (text, value) => {
        if (value === undefined) {
            value = text;
        }
        return `
            <li class="custom-select--item" tabindex="-1" data-select-value="${text.trim()}">
                <button class="w-100" data-value="${value}">
                    ${text}
                </button>
            </li>
        `;
    }

    convertArrayToJSON = () => {
        let data = {};
        this.vehiclesData.forEach(({ Year, Make, Model, Engine, URL }) => {
            if (!data[Year]) {
                data[Year] = {};
            }
            if (!data[Year][Make]) {
                data[Year][Make] = {};
            }
            if (!data[Year][Make][Model]) {
                data[Year][Make][Model] = {};
            }
            if (!data[Year][Make][Model][Engine]) {
                data[Year][Make][Model][Engine] = URL;
            }
        });

        this.vehiclesData = data;
    };

    getAllYears = () => {
        return Object.keys(this.vehiclesData);
    };

    getAllMakesForYear = (year) => {
        if (this.vehiclesData[year] && year != "") {
            var makeData = Object.keys(this.vehiclesData[year]);
            makeData = makeData.filter(item => item !== "");
            makeData.sort();
            var mostTopArray = [];
            if (window.most_top_make_array) {
                mostTopArray = window.most_top_make_array;
            }

            // Filter makes that are not in mostTopArray (others)
            mostTopArray = mostTopArray.filter(item => makeData.includes(item));
            let otherMakes = makeData.filter(item => !mostTopArray.includes(item));

            // Combine top makes, divider, and other makes
            let sortedArray = mostTopArray.length > 0 ? [...mostTopArray, '--------------------', ...otherMakes] : otherMakes;
            
            return sortedArray;
        }
        return [];
    };

    getAllModelsForYearAndMake = (year, make) => {
        if (this.vehiclesData[year] && this.vehiclesData[year][make]) {
            var modelData = Object.keys(this.vehiclesData[year][make]);
            modelData = modelData.filter(item => item !== "");
            modelData.sort();
            var mostTopArray = [];
            if (window.most_top_model_array) {
                mostTopArray = window.most_top_model_array;
            }

            // Filter models that are not in mostTopArray (others)
            mostTopArray = mostTopArray.filter(item => modelData.includes(item));
            let otherModels = modelData.filter(item => !mostTopArray.includes(item));

            // Combine top models, divider, and other models
            let sortedArray = mostTopArray.length > 0 ? [...mostTopArray, '--------------------', ...otherModels] : otherModels;
            return sortedArray;
        }
        return [];
    };

    getAllEnginesForYearMakeAndModel = (year, make, model) => {
        if (this.vehiclesData[year] && this.vehiclesData[year][make] && this.vehiclesData[year][make][model]) {
            return Object.keys(this.vehiclesData[year][make][model])?.sort().reverse();
        }
        return [];
    };

    getURLForYearMakeModelAndEngine = (year, make, model, engine) => {
        if (this.vehiclesData[year] && this.vehiclesData[year][make] && this.vehiclesData[year][make][model] && this.vehiclesData[year][make][model][engine]) {
            return this.vehiclesData[year][make][model][engine];
        }
        return null;
    };

    _isUniversalCompatible = (tags, vehicleYear) => {
        for (const tag of tags) {
            var parts = tag.split('-');
            if (parts[0].toLowerCase() !== 'universal') continue;
            if (parts.length === 1) return true;
            var minYear = parseInt(parts[1]);
            if (parseInt(vehicleYear) >= minYear) return true;
        }
        return false;
    };
}

customElements.define('year-make-model', YearMakeModel);
